import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile } from 'redux/saga/entities/bound';
import { memberStatus } from 'enums/memberStatus';

export function* profileOnEnterSaga(client, nextState, replaceState) {
  if (yield select(isLoggedIn)) {
    const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
    const { status } = profile.membership;

    if (status === memberStatus('CANCELLED')) {
      return yield call(replaceState, '/rejoin');
    }
    if (status === memberStatus('UNSUBSCRIBED')) {
      return yield call(replaceState, '/signup/continue');
    }
    return;
  }
  return yield call(replaceState, `/login${nextState.location.pathname}`);
}
